// router.js
import Vue from 'vue';
import Router from 'vue-router';
// import Sign from './components/sign.vue';
import Home from './Index.vue';
import Sign from './components/signMobile.vue';
//import Home from './IndexMobile.vue';
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'hm',
            component: Home
        },
        {
            path: '/sign',
            name: 'sign',
            component: Sign
        }
    ]
});
